import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { Avatar, Box, Chip, Menu, MenuItem, Typography } from '@mui/material';
import appConfig from '../../../config';
import { clearCookie, getGlobalCookie } from '../../../utils';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import SwitchAccountModal from '../../../lease_management/header_action/switch_account/SwitchAccountModal';
import { useDispatch, useSelector } from 'react-redux';
import { getUserLessorListApi } from '../../actionCreators';


const UserInfo = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [anchorEl, setAnchorEl] = useState(null);
    const [switcLessor, setSwitchLessor] = useState({ modal: false, data: null, })
    const { userLessorList } = useSelector((state) => state.leases)
    const lessorAccess = JSON.parse(getGlobalCookie('lessorAccess'))
    const userinfo = JSON.parse(getGlobalCookie('userName'))
    const hasMultiLessor=JSON.parse(getGlobalCookie('hasMultilLessorAccess'))
    const selectedLessor = userLessorList?.find( lessor => lessor?.id ==lessorAccess?.id );

    useEffect(() => {
        if(!userLessorList?.length){
          dispatch(getUserLessorListApi())
        }
      }, [])

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    
    const logout = () => {
        clearCookie('lessorAccess')
        clearCookie('redirectURIMaintenance')
        clearCookie('domain')
        clearCookie('userName')
        clearCookie('redirectURILease')
        navigate('/')
    }

    return (
        <>
            <span className='user-details' aria-controls="user-menu" aria-haspopup="true" onClick={handleClick}>
                <Avatar
                    alt={userinfo?.name}
                    src="/static/images/avatar/1.jpg"
                    sx={{ width: 35, height: 35 }}
                />
                <div className='user'>
                    <ul className="list-inline">
                        <li className='user-name'>{userinfo?.name}</li>
                        <li className='user-designation'>{userinfo?.designation}</li>
                    </ul>
                </div>
                <ArrowDropDownIcon style={{alignSelf:'center',marginLeft:'5px'}} fontSize='small' color='primary' />
            </span>
            <Menu
                id="user-menu"
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleClose}
                className='user-menu-list'
            >
                  <MenuItem onClick={() => { handleClose(); window.open(`${appConfig.domain.subDomian}user-profile/`, '_blank') }}>  
                    Profile                   
                </MenuItem>
                {userLessorList?.length > 1 ?
                    <MenuItem onClick={() => { setSwitchLessor({ modal: true, data: null }); handleClose(); }} sx={{ alignItems: "flex-start" }} >
                        <Box>
                            <Typography variant="body1" sx={{lineHeight:'1'}}>Switch Account</Typography>
                            <Chip label={selectedLessor?.name} variant="contained" size='small' sx={{ fontSize: "9px", height: "18px", marginRight:"5px"}}/>
                            {/* <Typography variant="caption" color="text.secondary" >
                               {selectedLessor?.name}
                            </Typography> */}
                        </Box>
                    </MenuItem>
                    : null}
                <MenuItem onClick={() => {handleClose(); setTimeout(() => logout(), 500);}}>Logout</MenuItem>
            </Menu>
            {
                switcLessor?.modal && 
                <SwitchAccountModal
                onToggleModal={() => setSwitchLessor({ modal: false, data: null, mode: '' })}
                />
            }
        </>
    )
}
export default (UserInfo); 